import React from 'react';
import { Chip, Icon } from '@saviynt/design-system';

import { testIds } from '../../../../shared/constants';

interface WaypointProgressChipProps {
  progressPercentage: number;
  isFixed?: boolean;
  isChipIcon?: boolean;
}

/**
 * WaypointProgressChip
 */
function WaypointProgressChip({
  progressPercentage,
  isFixed,
  isChipIcon,
}: WaypointProgressChipProps) {
  return (
    <Chip
      size='xxSmall'
      kind='outlined'
      label={`${progressPercentage}%`}
      color={progressPercentage === 100 ? 'success' : 'warning'}
      isInteractionDisabled
      className={isFixed ? 'ChatLeftPanel-WayPointButton-badge' : ''}
      leftIcon={
        isChipIcon ? (
          <Icon
            kind={
              progressPercentage === 100 ? 'CheckCircleOutline' : 'StatusToDo'
            }
          />
        ) : undefined
      }
      dataTestId={testIds.WAYPOINT_PROGRESS_CHIP}
    />
  );
}

WaypointProgressChip.defaultProps = {
  isFixed: false,
  isChipIcon: false,
};

export default WaypointProgressChip;
